module.exports = __webpack_public_path__ + "img/switch-camera.a1000c43.svg";